<template>
    <ul class="pagination" v-if="dataLength > perPage">
        <!-- <li class="pagination-switch" @click="prevPage" v-if="currentPage !== 1">Prev</li> -->
        <li class="pagination-button" @click="setCurrent(1)" v-if="rangeStart !== 1">1</li>
        <span class="dots" v-if="rangeStart !== 1">...</span>
        <li class="pagination-button"
            :class="{active: pageNumber === currentPage}"
            v-for="pageNumber in pages"
            :key="pageNumber"
            @click="setCurrent(pageNumber)">
            <span :class="{'active-span': pageNumber === currentPage }">{{ pageNumber }}</span>
        </li>
        <span class="dots" v-if="currentPage < (totalPages - 2)">...</span>
        <li
                class="pagination-button"
                v-if="currentPage < (totalPages - 2)"
                @click="setCurrent(totalPages)">
            {{ totalPages }}
        </li>

        <!-- <li class="pagination-switch" v-if="currentPage < totalPages" @click="nextPage">Next</li> -->
    </ul>
</template>

<script>
    //*****************
    // Create two properties in parent component 'currentPage: 1' and 'perPage: yourValue'
    // Bind pagination component custom event 'set-current' in which assign given parameter value to this.currentPage property
    // Thats all
    //********************

    export default {
        props: {
            pageNumber: {
                type: Number
            },
            dataLength: {
                type: Number
            },

            // currentPage: {
            //     type: Number
            // },

            pageRange: {
                type: Number,
                default: 2
            },

            perPage: {
                type: Number
            }
        },

        data() {
            return {
                currentPage: 1,
                routeName: ""
            }
        },

        watch: {
            currentPage: function(){

            },

            pageNumber: function () {
                if(this.currentPage != this.pageNumber)this.currentPage = this.pageNumber;
            },
            '$route.query.page' : {
                immediate: true,
                handler(val) {
                  this.currentPage = val ? parseInt(val) : 1;
                  val ? this.$emit('set-current', parseInt(val)) : '';
                }
            }
        },

        computed: {

            pages: function() {
                let pages = []

                for(var i = this.rangeStart; i <= this.rangeEnd; i++)
                    pages.push(i)

                return pages
            },

            rangeStart: function() {
                let start = this.currentPage - this.pageRange

                return (start > 0) ? start : 1
            },

            rangeEnd: function() {
                let end = this.currentPage + this.pageRange

                return (end < this.totalPages) ? end : this.totalPages
            },

            totalPages() {
                return Math.ceil(this.dataLength / this.perPage)
            }
        },

        methods: {
            toParent() {
                this.$emit('set-current', this.currentPage)
            },

            setCurrent(current) {
                this.currentPage = current
                this.toParent()
            },

            prevPage() {
                this.currentPage--
                this.toParent()
            },

            nextPage() {
                this.currentPage++
                this.toParent()
            }
        },

        mounted() {
            this.routeName = this.$route.name

            // console.log(this.routeName)
        }
    }
</script>

<style scoped>

    .pagination-button .img {
        position: absolute;
        left: 110%;
        top: 50%;
        transform: translate(-50%,-50%) scaleX(1.3);
        z-index: 0;
        transition: .6s;
        line-height: 0;
        width: 40px;
    }

    .pagination {
        display: flex;
        justify-content: center;
    }

    .pagination .pagination-button,
    .pagination .pagination-switch {

        font-size: 16px;
        color: #444958;
        font-weight: bold;
        cursor: pointer;
        margin-right: 3px;
        transition: all 400ms;
        position: relative;
        width: 25px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        border-radius: 4px;
        transition: all 600ms;
    }
    .pagination .pagination-button span,
    .pagination .pagination-switch span {
        font-size: 16px;
        color: #444958;
        font-weight: bold;
        cursor: pointer;
        position: relative;
        z-index: 3;
        transition: all 400ms;

    }

    .pagination .pagination-switch {
        width: auto;
        padding: 0 .5rem;
    }

    .pagination .pagination-button:hover,
    .pagination .pagination-switch:hover {
        color: #FFF;
        background: #ED1651;
        width: 25px;
        height: 25px;
        text-align: center;
    }

    .pagination .pagination-button:hover span ,
    .pagination .pagination-switch:hover span  {
        color: #FFF;
    }

    .pagination .pagination-button::selection,
    .dots::selection,
    .pagination .pagination-switch::selection {
        background: transparent
    }

    .active {
        background: #ED1651;
        width: 25px;
        height: 25px;
        text-align: center;
    }

    .pagination .pagination-button span.active-span {
        color: #fff;
    }

    .dots {
        margin-right: 10px;
        font-weight: 700;
    }
</style>
